module.exports = __webpack_public_path__ + "static/cad-designs29-fdb26fb98c4ed73de902f172470e737f.png";